/**
 * Created by LIDA1FH on 05/11/2016.
 */
module.exports = function (bootstrap) {

    bootstrap.directive('clientSideBarForm', ["$state", function ($state) {
        return {
            replace: true,
            template: require('directives/hmhs/clientSideBarForm.html'),

            link: function (scope, element) {
                /*
                 * Accepts a Form Config object on sidebar scope.
                 * Current Config Options:
                 * enforceSteps : true makes sure that state.go only happens if the previous steps are completed.
                 *
                 * */


                //Resolves Active Styling on stateChangeSuccess
                scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                    setActiveOn(toState.name);
                });

                var setActiveOn = function (state) {

                    for (var z in scope.sidebar.links) {
                        if (scope.sidebar.links[z].state === state) {
                            scope.sidebar.links[z].active = true;
                        } else if (scope.sidebar.links[z].state.substring(0, scope.sidebar.links[z].state.indexOf('(')) === state) {
                            scope.sidebar.links[z].active = true;
                        } else {
                            scope.sidebar.links[z].active = false;
                        }
                    }

                    return state;

                };

                //Enforcing Steps in Order
                function allowStepClick(array, link) {

                    //var getThis = array.filter(
                    //    function (item) {
                    //        return item.heading === link.heading;
                    //    })


                    var endAt = array.indexOf(link);

                    var checkHidden = 0;
                    var checkApproved = 0;

                    for (var i = 0; i < endAt; i++) {

                        if (array[i].approved && !array[i].hidden) {
                            checkApproved++;
                        }
                        if (array[i].hideItem) {
                            checkHidden++;
                        }
                    }

                    // Return false if not enough approved steps.
                    if (checkApproved >= endAt - checkHidden) { return true; }
                    else { return false; }

                }

                scope.goStep = function (link) {

                    if (scope.sidebar.formConfig.enforceSteps === true) {
                        var checkAllow = allowStepClick(scope.sidebar.links, link);
                        if (checkAllow) {
                            $state.go(link.state);
                        }
                    } else {
                        //goCallback();                    }
                        $state.go(link.state);
                    }

                };


                // Initialization Logic
                var setActive = function (link) {

                    for (var z in scope.sidebar.links) {
                        if (scope.sidebar.links[z].state === link.state) {
                            link.active = true;
                        } else if (scope.sidebar.links[z].state.substring(0, scope.sidebar.links[z].state.indexOf('(')) === link.state) {
                            link.active = true;
                        } else {
                            scope.sidebar.links[z].active = false;
                        }
                    }

                    return link;

                };

                var linkFromState = function (state) {

                    for (var z in scope.sidebar.links) {
                        if (scope.sidebar.links[z].state === state) {
                            return scope.sidebar.links[z];
                        } else if (scope.sidebar.links[z].state.substring(0, scope.sidebar.links[z].state.indexOf('(')) === state) {
                            return scope.sidebar.links[z];
                        }
                    }

                };


                var initState = function () {

                    var link = linkFromState($state.current.name);

                    if (link) {
                        if (scope.sidebar.formConfig.enforceSteps === true && !allowStepClick(scope.sidebar.links, link)) {
                            setActive(scope.sidebar.links && scope.sidebar.links[0]);
                            $state.go(scope.sidebar.links[0].state);
                        }
                        setActive(link);

                    }

                    else {
                        // No link found.  Select 1st link.  This needs changed later to be an option rather than the default behaviour
                        setActive(scope.sidebar.links && scope.sidebar.links[0]);

                    }

                };


                scope.$watch('sidebar.links', function () {
                    initState();
                });

            }
        };
    }]);
};